export const snakeCaseArrayWords = (word) => {
  return word.toLowerCase();
};

export function snakeCase(text: string): string {
  const stringArray = text.match(/([A-Z]?)[a-z0-9]+/g);
  return stringArray.map(snakeCaseArrayWords).join("_");
}
